import { render, staticRenderFns } from "./hklhc.vue?vue&type=template&id=273847d2&scoped=true"
var script = {}
import style0 from "./hklhc.vue?vue&type=style&index=0&id=273847d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273847d2",
  null
  
)

export default component.exports